import { NFTS_PROFILE_ACTIONS } from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'
import { SORTING_OPTIONS } from '../../../constants/dashboard'
import { sortNftsByDateASC } from '../../../util/nft.helpers'
import { sortRecordsByNameASC } from '../../../util/exchange.helpers'
import {
  QB_DEFAULT_NFT_SORTING,
  QB_DEFAULT_NFT_STATUS
} from '../../../constants/app'

export const nftsListProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case NFTS_PROFILE_ACTIONS.ON_GET_NFTS_SUCCESS:
      return mergeToNewObject(state, {
        nfts: changeNftsSorting(state.sorting, payload)
      })

    case NFTS_PROFILE_ACTIONS.CHANGE_STATE:
      const { property, value } = payload
      return mergeToNewObject(
        state,
        { [payload.property]: payload.value },
        handleNftsFiltersSorting(property, value, state.nfts)
      )

    case NFTS_PROFILE_ACTIONS.ON_UPDATE_NFT_SUCCESS:
      return mergeToNewObject(state, {
        nfts: state.nfts.map((nft) =>
          nft.id === payload.id ? { ...nft, canRedeem: payload.canRedeem } : nft
        ),
        selectedNft: payload
      })

    case NFTS_PROFILE_ACTIONS.ON_UPDATE_SELECTED_NFT:
      return mergeToNewObject(state, {
        selectedNft: payload.nft
      })

    default:
      return state
  }
}

const INITIAL_STATE = {
  nfts: [],
  selectedNft: '',

  sorting: QB_DEFAULT_NFT_SORTING,
  status: QB_DEFAULT_NFT_STATUS
}

export const NFTS_LIST_PROFILE_DISPATCH = {
  SORTING: 'sorting',
  STATUS: 'status'
}

const handleNftsFiltersSorting = (property, value, state) => {
  switch (property) {
    case NFTS_LIST_PROFILE_DISPATCH.SORTING:
      return changeNftsSorting(value, state)
    default:
      return ''
  }
}

const changeNftsSorting = (value, nfts) => {
  switch (value) {
    case SORTING_OPTIONS.ALPHABETICAL:
      return sortRecordsByNameASC(nfts)
    default:
      return sortNftsByDateASC(nfts)
  }
}
